import Axios from 'axios';
import { Auth } from '../session/types';
export class RestService {
    constructor(config) {
        this.http = Axios.create(config);
        this.http.interceptors.request.use(this.handleRequestIntercept.bind(this));
        this.http.interceptors.response.use(this.handleResponseIntercept.bind(this));
        this.token = localStorage.getItem('kauth');
    }
    setToken(token) {
        this.token = token;
    }
    handleRequestIntercept(req) {
        req.headers.jwt = this.token;
        req.headers['Content-Type'] = 'application/json';
        return req;
    }
    handleResponseIntercept(res) {
        // Dispatch an expired session event for unauthorized responses, otherwise renew the current session timeout
        const event = new Event(res.status === 401 ? Auth.EXPIRED_SESSION : Auth.RENEW_SESSION);
        dispatchEvent(event);
        return res;
    }
    get(url, config) {
        return this.http.get(url, config);
    }
    post(url, data, config) {
        return this.http.post(url, data, config);
    }
    put(url, data, config) {
        return this.http.put(url, data, config);
    }
    patch(url, data, config) {
        return this.http.patch(url, data, config);
    }
    delete(url, config) {
        return this.http.delete(url, config);
    }
}
